export default {
  authHeaders () {
    return {
      'Authorization': `Bearer ${this.$store.state.session.token}`
    }
  }
}
